import stringUtils from '../../utils/stringUtils';
import log from '../logger/log';
import LocalizationManager from './LocalizationManager';

const localizationManager = new LocalizationManager();
const localizationInstance = localizationManager.getInstance();
const localization = localizationInstance.getLocalization();

export const t = (key) => localization[key] || '';

export const translateByDefaultLanguage = (key) => getFallbackDictionary()?.[key] || '';

const getFallbackLanguageCode = () => localizationManager.fallbackLanguageCode;
const getFallbackMarketCode = () => localizationManager.fallbackMarketCode;
const getFallbackLocalizationName = () => localizationManager.fallbackLocalizationName;
const getFallbackDictionary = () => localizationManager.fallbackDictionary;

const setActiveLanguage = (lang) => {
    log.debug(`localizationService: Setting active language: ${lang}`);

    return localization.setLanguage(lang);
};
const getActiveLanguage = () => {
    const activeLanguage = localization.getLanguage();

    log.debug(`localizationService: Active language: ${activeLanguage}`);

    return activeLanguage;
};

const resetDictionary = () => {
    const fallbackLocalizationName = getFallbackLocalizationName();
    const fallbackDictionary = getFallbackDictionary();

    localization.setContent({[fallbackLocalizationName]: fallbackDictionary});
};

const setLanguageDictionary = (lang, dictionary) => {
    resetDictionary();
    const data = {[lang]: dictionary};

    log.debug(`localizationService: Setting dictionary for language: ${lang}`);

    return localization.setContent(data);
};

const applyNewLocalizationData = (localizationName, dictionary) => {
    setLanguageDictionary(localizationName, dictionary);
    setActiveLanguage(localizationName);
};

export const formatString = (key, ...values) => {
    const string = t(key);

    return stringUtils.formatString(string, ...values);
};

export const parseList = (key) => {
    const string = t(key);

    return stringUtils.parseList(string);
};

export const getLocalizationData = () => {
    return stringUtils.deepCloneData(localization);
};

export default {
    setActiveLanguage,
    setLanguageDictionary,
    getFallbackLanguageCode,
    applyNewLocalizationData,
    getActiveLanguage,
    getFallbackDictionary,
    getFallbackMarketCode,
    getFallbackLocalizationName,
};
